import { lcrStatusLabelFor } from "./order-display.mapper";
import { Order, ORDER_SOURCE_IDS } from "@/services/orders/orders.types";
import { LcrOrder } from "./lcr-order.types";

const REPLACEMENT_ITEM_NAME = "Replacement laptop";

export const toOrder = (lcr: LcrOrder): Order => ({
  orderId: lcr.orderId,
  orderReference: lcr.orderId,
  source: ORDER_SOURCE_IDS.lcr,
  deliveryMethod: lcr.submission.deliveryMethod,
  status: lcr.lcrStatus,
  statusLabel: lcrStatusLabelFor(lcr.lcrStatus, lcr.submission.deliveryMethod),
  replacedSerialNumber: lcr.serialNumber,
  requested: { on: lcr.acceptedAt },
  items: [
    {
      itemId: lcr.submission.newHardware.laptop,
      itemInformation: {
        name:
          `${lcr.selectedDevice.make} ${lcr.selectedDevice.model}`.trim() || REPLACEMENT_ITEM_NAME,
      },
    },
  ],
});
